
<app-shared [type]="'bon-transfert'" [status]="'Annulé'"></app-shared>
